<template>
    <div
        class="h-9 flex relative items-center gap-2"
        :class="{
            'md:w-1/3 w-full': origin === 'favorites',
            'max-sm:w-full shadow dark:shadow-slate-900/50 rounded bg-white dark:bg-slate-800 w-auto': origin === 'map',
            'justify-center sm:justify-start': origin === 'map',
            'justify-start': origin === 'favorites',
        }"
    >
        <label for="search" class="sr-only">Search Favorites</label>
        <div
            class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-800"
        >
            <i class="fa-solid fa-magnifying-glass fa-xs"></i>
        </div>
        <input
            class="rounded"
            :class="{
                'w-full pr-4 pl-10 py-2 bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 border border-slate-300 text-slate-500 text-sm font-normal leading-tight hover:border-slate-800 focus:border-slate-800 focus:outline-none focus:ring-0 placeholder:text-slate-500':
                    origin === 'favorites',
                'border border-slate-300 w-auto h-full text-slate-800 text-sm font-medium placeholder:text-slate-800 placeholder:text-sm placeholder:leading-tight placeholder:text-left placeholder:font-medium hover:bg-slate-200 active:border-slate-200 focus:outline-none focus:ring-inset focus:ring-slate-200 focus:ring-2 focus:border-slate-200 pl-8 pr-3 py-2':
                    origin === 'map',
            }"
            id="favoritesSearch"
            name="search"
            type="text"
            v-model="searchTerm"
            :placeholder="
                origin === 'favorites'
                    ? 'Search by name or location'
                    : 'Name or location'
            "
            @input="debounceSearch"
        />
        <ClearInputButton
            v-show="searchTerm"
            @clear="handleClear"
            class="absolute right-2"
        />
        <div
            class="h-fit w-full bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 justify-center items-center flex flex-col absolute inset-y-full left-0 mt-3 z-10"
            v-if="
                showOnMap &&
                !Object.values(filteredFavs).flat().length &&
                !loading
            "
        >
            <EmptyState
                title="No matching hotels found"
                description="Try changing your search parameters."
                :hasAction="false"
                containerStyles="p-3 text-center"
            />
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { debounce } from 'lodash';
import ClearInputButton from '@/components/ui/clear-input-button/clear-input-button.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';

export default {
    props: {
        origin: {
            type: String,
            default: 'favorites',
        },
    },
    components: { ClearInputButton, EmptyState },
    setup() {
        const hotelsStore = useHotelsStore();
        const { getUsersFavHotels, setFavSearchQuery } = hotelsStore;
        const { favSearchQuery, showOnMap, filteredFavs, loading } =
            storeToRefs(hotelsStore);

        const searchTerm = computed({
            get() {
                return favSearchQuery.value;
            },
            set(val) {
                setFavSearchQuery(val);
            },
        });

        const handleClear = async () => {
            searchTerm.value = null;
            searchFavs();
        };

        const debounceSearch = debounce(() => {
            searchFavs();
        }, 600);

        const searchFavs = async () => {
            setFavSearchQuery(searchTerm.value);
            await getUsersFavHotels();
        };

        onMounted(() => {
            if (searchTerm.value) {
                searchFavs();
            }
        });

        return {
            searchTerm,
            handleClear,
            debounceSearch,
            showOnMap,
            filteredFavs,
            loading,
        };
    },
};
</script>
